<template>
  <div class="content">
    <template v-for="block in content">
      <h1 :key="block.id" v-if="block.type == 'h1'" v-html="block.content" />
      <h2 :key="block.id" v-if="block.type == 'h2'" v-html="block.content" />
      <p
        :key="block.id"
        v-if="block.type == 'paragraph'"
        v-html="block.content"
      />
      <hr :key="block.id" v-if="block.type == 'hr'" />
      <li :key="block.id" v-if="block.type == 'ul'" v-html="block.content" />
      <li :key="block.id" v-if="block.type == 'ol'" v-html="block.content" />
      <div
        class="code"
        :key="block.id"
        v-if="block.type == 'code'"
        v-html="block.content"
      />
      <blockquote
        :key="block.id"
        v-if="block.type == 'blockquote'"
        v-html="block.content"
      />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    content: Array
  }
};
</script>

<style lang="scss" scoped>
h1,
p {
  margin-bottom: var(--lh);
}
li {
  list-style: none;
  padding-left: calc(2 * var(--lh));
  position: relative;
  &:before {
    content: "–";
    position: absolute;
    top: 0;
    left: 0;
  }
  + h1,
  + p {
    margin-top: var(--lh);
  }
}
.content {
  position: relative;
  width: 100%;
  @media only print {
    page-break-inside: avoid;
  }
}
.image {
  // position: absolute;
  // left: calc(100% + 1px + (0.5 * var(--lh)));
  width: 100%;
  // padding: calc(0.5 * var(--lh));
  padding-top: 0;
  cursor: default;
  img {
    width: 100%;
    max-height: 60vh;
    object-fit: contain;
    object-position: top left;
  }
}
</style>
